<ng-container *appTranslate="let t">
  <div class="page" style="background: var(--p-gradient)">
    <ui-pageheader
      class="bg-transparent"
      [caption]="title"
      [description]="dashboardVisibility()?.isVisible ? t('dashboard.description') : undefined"
    />

    @if (dashboardVisibility().isVisible) {
      <article class="content">
        <div class="p-11 grid auto-rows-[272px] grid-cols-1 mobile:grid-cols-4 gap-4">
          <new-ui-dashboard-open-tasks
            class="col-span-1"
            [class.mobile:col-span-2]="!settings.isCandidate"
            [class.mobile:col-span-4]="settings.isCandidate"
          />
          @if (!settings.isCandidate) {
            <new-ui-dashboard-sharing class="col-span-1 mobile:col-span-2" />

            <new-ui-dashboard-events class="col-span-1 mobile:col-span-2" />
            <new-ui-dashboard-candidate-status class="col-span-1 mobile:col-span-2" />

            @if (dashboardVisibility().talentPool) {
              <new-ui-dashboard-talent-pool-requests class="col-span-1 mobile:col-span-2" />
              <new-ui-dashboard-talent-pool-sharings class="col-span-1 mobile:col-span-2" />
            }

            <new-ui-dashboard-milestone
              class="col-span-1 mobile:col-span-4"
              [class.row-span-2]="milestoneRowCount > 1"
              [class.row-span-3]="milestoneRowCount > 4"
              (rowCount)="onMilestoneRowCountChange($event)"
            />
            <new-ui-dashboard-birthdays class="col-span-1 row-span-2" />

            <new-ui-dashboard-release-notes-notes class="col-span-1 mobile:col-span-3 row-span-2" />
          } @else {
            <new-ui-dashboard-milestone-candidate class="col-span-1 mobile:col-span-4" />
          }
        </div>
      </article>
    }
  </div>
</ng-container>
